import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { committeeActions } from "../../../_store/committee.slice";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { useNavigate, Link } from "react-router-dom";
import CommitteeIcon from "../../../assets/svg/committee-icon.svg";
import { useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../../../assets/css/MainSlider.css";

export default function CommitteeSliderInMainPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [committeeList, setCommitteeList] = useState([]);

  useEffect(() => {
    dispatch(committeeActions?.sliderForHomePage("limit=50"))
      .then((result) => {
        if (result?.payload?.status === 1) {
          setCommitteeList(result?.payload?.data?.committees || []);
        }
      })
      .catch(() => {
        showToastNotification("Failed to load committees", "error");
      });
  }, [dispatch]);

  const handleCardClick = (item) => {
    navigate(`/Committee/${item?._id}`, {
      state: { committeeID: item },
    });
  };

  // const reverserdArr = [...committeeList].reverse();

  return (
    <>
      {committeeList?.length > 0 && (
        <section className="bcsp-committee" id="bcsp-committee-slider">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* Title + Navigation arrows */}
                <div className="committee-header">
                  <div>
                    <h2 className="main-title">BPK Committees</h2>
                  </div>

                  {/* Custom arrows container */}
                  {committeeList?.length > 4 && (
                    <div className="swiper-nav">
                      <div
                        className="swiper-button-prev"
                        role="button"
                        tabIndex={0}
                        aria-label="Previous slide"
                      ></div>
                      <div
                        className="swiper-button-next"
                        role="button"
                        tabIndex={0}
                        aria-label="Next slide"
                      ></div>
                    </div>
                  )}
                </div>

                {/* Slider */}
                <Swiper
                  modules={[Navigation, Autoplay]}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  spaceBetween={20}
                  slidesPerView={4}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 4 },
                  }}
                  loop={true}
                  style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                >
                  {committeeList?.map((item) => (
                    <SwiperSlide key={item?._id}>
                      <button
                        role="button"
                        className="committee-card"
                        onClick={() => handleCardClick(item)}
                        tabIndex={0}
                        aria-label={`View ${item?.committeeName} details`}
                      >
                        <div className="card-icon">
                          <img
                            src={
                              item?.committeeImage
                                ? process.env.REACT_APP_API_IMAGE_URL +
                                  item?.committeeImage
                                : CommitteeIcon
                            }
                            alt={
                              item?.committeeName
                                ? `${item.committeeName} logo`
                                : "Committee logo"
                            }
                          />
                        </div>
                        <div
                          className="card-title"
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.committeeName}
                        </div>
                      </button>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div className="div-center mt-4">
                  <Link
                    to="/BPKCommittees"
                    className="cta-button"
                    aria-label="View all BPK committees"
                  >
                    View All Committees
                    {/* <i className="csc-arrow-icon bi bi-arrow-right"></i> */}
                    <i
                      className="arrow-icon-btn bi bi-arrow-right"
                      aria-hidden="true"
                    ></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
